module.exports = __webpack_public_path__ + "14786f97d1d19fc188a0893f2c6a48be.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/broom.png
// module id = 1995
// module chunks = 0